// extracted by mini-css-extract-plugin
export var hidden = "_vn-0";